import { Flex, Link, Text } from '@foradevelopment/fora-ui';
import { FileReportUploadViewModel } from '@fora-monorepo/employer-my-pages-common/types';

import { HistoryLogItem, HistoryLogList } from './HistoryLogList';
import { links } from '../../router/links';
import { changeEmployerAndGetToken } from '../../redux/auth/authThunks';
import { useAppDispatch } from '../../redux/hooks';
import { useTypedTranslation } from '../../i18n/i18n';

export type HistoryLogFilesData = Pick<
  FileReportUploadViewModel,
  'fileName' | 'organizationName' | 'organizationNumber' | 'partnerNumberOrganization' | 'reportedAt'
>;

type HistoryLogFiles = {
  data: HistoryLogFilesData[];
  title: string;
};

export const HistoryLogFiles = ({ data, title }: HistoryLogFiles) => {
  const { t } = useTypedTranslation();
  const dispatch = useAppDispatch();

  const handleClick = (partnerNumberOrganization: string | null) => {
    dispatch(changeEmployerAndGetToken({ partnerNumberOrganization }));
  };

  return (
    <HistoryLogList title={title}>
      {data.map((item, index) => (
        <HistoryLogItem date={item.reportedAt} key={index} index={index}>
          <Flex flexDirection="column" alignItems="flex-start" rowGap={1}>
            <Text color="black70"> {item.fileName || t('section.reportHistory.filenameMissing')} </Text>
            <Text>
              {item.organizationName} {item.organizationNumber}
            </Text>
            <Link to={links.fileDashboard} onClick={() => handleClick(item.partnerNumberOrganization)}>
              {t('list.historyLog.linkToOrganization', { organizationName: item.organizationName })}
            </Link>
          </Flex>
        </HistoryLogItem>
      ))}
    </HistoryLogList>
  );
};
